export default __webpack_public_path__ + "static/media/kleinbus_front.1e0598cd.jpg";